import {
  REGISTER_ACTION,
  CLEAR_REGISTER_STATE_ACTION,
} from '../actions/auth-actions';

import { thriftPlugin } from '../thriftPlugin';
import {
  valueInArray,
} from './utils/auth-utils';
import {
  NONE,
  PENDING,
  SUCCESS,
  FAILED,
} from '../consts';

const AUTH_ITEM = 'isAuthenticated';

export default {
  state: {
    authenticated: !!localStorage.getItem(AUTH_ITEM),
    loginRegistrationState: {
      checked: false,
      lengthIsOk: null,
      occupied: null,
    },
    emailRegistrationState: {
      checked: false,
      lengthIsOk: null,
      valid: null,
      occupied: null,
    },
    passwordRegistrationState: {
      checked: false,
      lengthIsOk: null,
    },
    registrationState: NONE,
  },
  actions: {
    [CLEAR_REGISTER_STATE_ACTION](ctx) {
      ctx.commit('initRegistrationState', { userName: true, password: true, email: true });
    },
    [REGISTER_ACTION](ctx, payload) {
      ctx.commit('initRegistrationState', {
        userName: true,
        password: true,
        email: true,
        sendRequest: true,
      });
      thriftPlugin.AuthService.tryToRegisterNewUser(payload.login, payload.email, payload.password)
        .then(
          (response) => {
            ctx.commit('setRegisterState', response);
          },
        );
    },
  },
  mutations: {
    initRegistrationState(state, payload) {
      if (payload.sendRequest === true) {
        state.registrationState = PENDING;
      } else {
        state.registrationState = NONE;
      }
      if (payload.userName === true) {
        state.loginRegistrationState = {
          checked: false,
          lengthIsOk: null,
          occupied: null,
        };
      }
      if (payload.password === true) {
        state.passwordRegistrationState = {
          checked: false,
          lengthIsOk: null,
        };
      }
      if (payload.email === true) {
        state.emailRegistrationState = {
          checked: false,
          lengthIsOk: null,
          valid: null,
          occupied: null,
        };
      }
    },
    setRegisterState(state, results) {
      if (
        valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.USERNAME_IS_EMPTY, results)
        || valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.USERNAME_LENGTH_ERROR, results)
      ) {
        state.loginRegistrationState.checked = true;
        state.loginRegistrationState.lengthIsOk = false;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.USERNAME_IS_OCCUPIED, results)) {
        state.loginRegistrationState.checked = true;
        state.loginRegistrationState.occupied = true;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.USERNAME_OK, results)) {
        state.loginRegistrationState.checked = true;
        state.loginRegistrationState.occupied = false;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.EMAIL_IS_OCCUPIED, results)) {
        state.emailRegistrationState.checked = true;
        state.emailRegistrationState.occupied = true;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.EMAIL_INVALID, results)) {
        state.emailRegistrationState.checked = true;
        state.emailRegistrationState.valid = false;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.EMAIL_TOO_LONG, results)) {
        state.emailRegistrationState.checked = true;
        state.emailRegistrationState.lengthIsOk = false;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.EMAIL_OK, results)) {
        state.emailRegistrationState.checked = true;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.PASSWORD_WRONG, results)) {
        state.passwordRegistrationState.checked = true;
        state.passwordRegistrationState.lengthIsOk = false;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.PASSWORD_OK, results)) {
        state.passwordRegistrationState.checked = true;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.REGISTRATION_IS_SUCCEED, results)) {
        state.registrationState = SUCCESS;
      }
      if (valueInArray(thriftPlugin.authTypes.REGISTER_STATUS.REGISTRATION_IS_FAILED, results)) {
        state.registrationState = FAILED;
      }
    },
  },
  getters: {
    isAuthenticated: (state) => state.authenticated,
    loginRegistrationState: (state) => state.loginRegistrationState,
    emailRegistrationState: (state) => state.emailRegistrationState,
    passwordRegistrationState: (state) => state.passwordRegistrationState,
    registrationState: (state) => state.registrationState,
  },
};
